import showToast from "common/Notification";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  addPrescriberFail,
  addPrescriberSuccess,
  deletePrescriberFail,
  deletePrescriberSuccess,
  getPrescribersFail,
  getPrescribersSuccess,
  getTaskPrescribersFail,
  getTaskPrescribersSuccess,
  updatePrescriberFail,
  updatePrescriberSuccess,
} from "./actions";
import { ADD_PRESCRIBER, DELETE_PRESCRIBER, GET_PRESCRIBERS_LIST, GET_TASK_PRESCRIBERS_LIST, UPDATE_PRESCRIBER } from "./actionType";
import { onGettingTaskPrescriberList, onGettingPrescribers, onAddingPrescriber, onUpdatingPrescriber, onDeletingPrescriber } from "helpers/fakebackend_helper";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Medication";

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingPrescriber, data);
    yield call(responseHandler, toastTitle, response, deletePrescriberSuccess, deletePrescriberFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(deletePrescriberFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingPrescriber, data);
    yield call(responseHandler, toastTitle, response, updatePrescriberSuccess, updatePrescriberFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(updatePrescriberFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingPrescriber, data);
    yield call(responseHandler, toastTitle, response, addPrescriberSuccess, addPrescriberFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(addPrescriberFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingPrescribers, data);
    yield call(responseHandler, toastTitle, response, getPrescribersSuccess, getPrescribersFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getPrescribersFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetTaskPrescriberList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTaskPrescriberList, data);
    yield call(responseHandler, toastTitle, response, getTaskPrescribersSuccess, getTaskPrescribersFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getTaskPrescribersFail(error));
    showToast("error", toastTitle, error);
  }
}

function* PrescriberSaga() {
  yield takeEvery(GET_PRESCRIBERS_LIST, onGet);
  yield takeEvery(DELETE_PRESCRIBER, onDelete);
  yield takeEvery(UPDATE_PRESCRIBER, onUpdate);
  yield takeEvery(ADD_PRESCRIBER, onAdd);
  yield takeEvery(GET_TASK_PRESCRIBERS_LIST, onGetTaskPrescriberList);
}

export default PrescriberSaga;
